module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_5010.1f11c58e.png";